import { TabProps as MuiTabProps } from '@mui/material/Tab';
import { StyledTab } from './styles';

export interface TabProps extends MuiTabProps {}

export default function Tab(props: TabProps) {
  const { disableRipple = true, children, ...tabProps } = props;

  return (
    <StyledTab disableRipple={disableRipple} {...tabProps}>
      {children}
    </StyledTab>
  );
}
